import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { NewBookingStatsPoint } from '../../../../types/dashboard';
import GenericTable from '../../../../shared/GenericTable';
import { dashboardSummaryTableDefaults } from '../../dashboardReportTableConfig';

type NewReservationsReportListProps = {
    points: NewBookingStatsPoint[];
    categoryLabel?: string;
};

type SummaryRow = NewBookingStatsPoint & { id: number };

export default function NewReservationsReportList({
    points,
    categoryLabel = 'Category',
}: NewReservationsReportListProps) {
    const columns: MRT_ColumnDef<SummaryRow>[] = useMemo(
        () => [
            {
                accessorKey: 'label',
                header: categoryLabel,
                size: 180,
            },
            {
                accessorKey: 'bookingCount',
                header: 'Reservations',
                size: 120,
            },
        ],
        [categoryLabel],
    );

    const rows = useMemo(
        () =>
            (points ?? []).map((point, index) => ({
                id: index + 1,
                ...point,
            })),
        [points],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No new reservations found for this selection.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardSummaryTableDefaults}
                columns={columns}
                data={rows}
                tableName='New Reservations Summary'
            />
        </Box>
    );
}
